import { ProjectKey } from '@/types/projectKey';

// 予測水位スパンの時間を定義
export const YskSpanHours = {
  H72: 72,
  H96: 96,
} as const;

// 予測水位スパンのスケールの型
type YskSpanScale = {
  value: number;
  text: string;
};

// 非表示にする予測水位スパンの値を定義
const hiddenYskSpanValues: Partial<Record<ProjectKey, readonly number[]>> = {
  [ProjectKey.Oita]: [96],
} as const;

/**
 * 指定されたプロジェクトキーに基づいて、非表示の予測水位スパンを除外したスケールの配列を返す関数
 * @param scales 予測水位スパンのスケールの配列
 * @param projectKey プロジェクトキー
 * @returns 非表示の予測水位スパンを除外したスケールの配列
 */
export const filteredYskSpanValues = (
  scales: YskSpanScale[],
  projectKey: ProjectKey | null,
): YskSpanScale[] => {
  // 指定されたプロジェクトキーに対応する非表示の予測水位スパンの値を取得
  const hiddenValues = projectKey ? hiddenYskSpanValues[projectKey] ?? [] : [];
  return scales.filter((scale) => !hiddenValues.includes(scale.value));
};
